import React, { useContext } from 'react'
import { ProductsContext } from '../../ProductsContext';

interface CategoryDropDownProps {
    value: string | null | undefined,
    handleSelect: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

const CategoryDropDown = ({ value, handleSelect }: CategoryDropDownProps) => {
    const prodContext = useContext<any>(ProductsContext);
    return (
        <div className='tw-flex tw-items-center'>
            <select className={`form-select tw-text-sm shadow-none`}
                value={value ?? ''}
                onChange={handleSelect}>
                <option value="" disabled selected>
                    Select Target Category
                </option>
                {prodContext.categoryData.map((item: any, index: any) => {
                    return (
                        <optgroup className="tw-text-xs" label={item.name} key={item.name}>
                            {item.category.map((category: any) => (
                                <option value={category.id} disabled={prodContext?.selected_Category?.id === category.id} key={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </optgroup>
                    );
                })}
            </select>
        </div>
    )
}

export default CategoryDropDown